'use client'
import { usePathname } from 'next/navigation'
import { About } from '../parts/solution/About'
import { Arrow } from '../parts/solution/Arrow'
import { Assignment } from '../parts/solution/Assignment'
import { AnchorRequest } from '../parts/AnchorRequest'
import { Solution } from '../parts/solution/Solution'
import { Reason } from '../parts/solution/Reason'
import { Security } from '../parts/Security'
import { DocumentForm } from '../forms/DocumentForm'
import { Contact } from '@/components/parts/contact'
import { Department } from '@/types/newt/department'
import { Opportunity } from '@/types/newt/opportunity'
import { Video } from '@/app/components/templates/non-block/Video'

type SolutionPageProps = {
  departments: Department[]
  currentUrl: string
  opportunities: Opportunity[]
}

const SolutionContent: React.FC<SolutionPageProps> = ({
  departments,
  opportunities,
  currentUrl
}) => {
  const pathname = usePathname()
  const showVideo = pathname === '/contract/' || pathname === '/contract'

  return (
    <>
      {showVideo && <Video />}
      <About />
      <Arrow />
      <Assignment />
      <AnchorRequest position="" />
      <Solution />
      <Reason />
      <Security />
      <DocumentForm
        bg="bg-lawguebase"
        departments={departments}
        opportunities={opportunities}
      />
      <Contact bg="" />
    </>
  )
}

export default SolutionContent
